import React from "react";
import "./TransactionFailed.style.scss";
import PropTypes from "prop-types";
import {_t} from "../../../../../utils/I18nUtils";
const TransactionFailed = ({ vm})=>{
    return <div className="TransactionFailed">
        <h2><i className="fa fa-fw fa-times-circle"
               style={{color: '#f34343'}}/> {_t(`views.addFundView.paymentFailed`)}</h2>
        <p>{_t(`views.addFundView.paymentProcessErrorMsg`)}</p>
        {vm.errors?.length > 0 && <div className="validation-summary-errors">
            <ul>{vm.errors.map((e, i) => <li key={`error${i++}`}>{e}</li>)}</ul>
        </div>}
        <div className="buttonsBar text-center">
            <a onClick={()=>vm.handleReturnToProdSelectionClick()}
               className="btn btn-primary btn-md">{_t(`views.addFundView.returnBtn`)}</a>
        </div>
        <div className="secureDepositDetails"><span> {/*t(`views.addFundView.secureDepositDetails`)*/} </span></div>
    </div>
};

TransactionFailed.propTypes = {
    vm: PropTypes.object
};

export default TransactionFailed;